/**
 * Keys that are not stored per environment type in session storage
 */
export enum RawSessionStorageKeys {
    flightSearchSearchControllerStorageKey= "flightSearch.searchControllerStorageKey",
    FlightSearchScheduleCache = 'flightSearch.scheduleCache',
    FlightSearchLowFaresCache = 'flightSearch.lowFaresCache',
}

